/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { ToolButtonWrapper } from '../tool-button-wrapper';
import { ToolButton } from '../topbar/tool-button';

export const StyledToolItem = styled(Space)`
  display: flex;
  align-items: center;
  padding: var(--spacing-02) var(--spacing-05);
  flex-basis: 100%;
  .ant-space-item {
    display: flex;
    align-items: center;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-basis: 100%;
`;

export const ToolItem = ({ onClick, children }) => {
  return (
    <Wrapper onClick={onClick}>
      <StyledToolItem align="center">{children}</StyledToolItem>
    </Wrapper>
  );
};

export const StyledMenu = styled(Menu)`
  .ant-dropdown-menu-item {
    padding: 0 !important;
  }
`;

export const Btn = styled(Button)`
  .ant-btn-icon-only {
    padding: 0;
    height: 20px;
    border: 0;
  }
`;

export const ToolBtn = styled(ToolButton)`
  width: 100%;
  padding: 0;
  :hover {
    background: transparent;
  }
`;

export const ToolBtnWrapper = styled(ToolButtonWrapper)`
  padding: 4px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  color: var(--icon-primary);
  svg:first-child {
    width: 20px;
    height: 20px;
  }
`;
